<template>
	<ValidationObserver v-slot="{ failed, valid, invalid, validated, passes, validate, handleSubmit, errors }" ref="observer">
		<v-snackbar
			v-model="failed"
			color="rgb(244, 67, 54)"
			outlined
			timeout="8000"
		>
			{{ $t('validation.errors') }}
			<!--			<template v-slot:action="{ attrs }">-->
			<!--				<v-btn-->
			<!--					text-->
			<!--					v-bind="attrs"-->
			<!--					@click="failed = false"-->
			<!--				>-->
			<!--					X-->
			<!--				</v-btn>-->
			<!--			</template>-->
		</v-snackbar>
		<div class="fill-height  pa-5 pa-sm-10" v-if="started_home" id="home-page"
		     :style='"background: url("+ AppStore.data.configuration[AppStore.locale].img +") no-repeat;background-size: cover;"'>
			<v-container fluid class="fill-height d-flex align-center flex-row">
				<v-row class="text-center" align="center" justify="center">
					<v-card v-if="!AppStore.mobileAlreadyPostRating" elevation="0" class="mx-auto pa-sm-10" rounded="xl"
					        :style="'margin-top:-'+negativeMarginTop+'px'">
						<v-col cols="12" class="text-h1 my-auto" id="home-title"
						       v-html="AppStore.data.configuration[AppStore.locale].title_1">
						</v-col>
						<v-col cols="12" class="text-center" id="home-stars">
							<div class="text-subtitle-1 text-center" id="subtitle"
							     v-if="AppStore.data.configuration[AppStore.locale].subtitle"
							     :style="'color:'+AppStore.data.general.secondary_color.hexa"
							     v-show="!_.includes([1,2,3,4,5], AppStore.rating.rate)"
							     v-html="AppStore.data.configuration[AppStore.locale].subtitle"></div>
							<v-rating v-model="AppStore.rating.rate" @input="EventBus.$emit('launchHomeWatcher', {})">
								<template v-slot:item="props">
									<v-icon
										:style="$vuetify.breakpoint.smAndUp ? 'font-size: 125px;' : 'font-size: 55px;'"
										:color="getRateColor(props.isFilled)"
										small
										:class="{
											'rate-icon-pulse': !AppStore.rating.rate && getAnimationType === 'pulse',
											'rate-icon-sparkle': !AppStore.rating.rate && getAnimationType === 'sparkle',
											'rate-icon-bounce': !AppStore.rating.rate && getAnimationType === 'bounce',
											'rate-icon-wave': !AppStore.rating.rate && getAnimationType === 'wave',
											'rate-icon-glow': !AppStore.rating.rate && getAnimationType === 'glow',
											'rate-icon-swing': !AppStore.rating.rate && getAnimationType === 'swing'
										}"
										class="pa-0"
										@click="props.click">
										{{ props.isFilled ? 'mdi-star' : 'mdi-star-outline' }}
									</v-icon>
								</template>
							</v-rating>
						</v-col>
						<v-col cols="12" id="home-questions"
						       v-if="questions_to_display && questions_to_display.length">
							<div v-for="(question, questionIndex) in questions_to_display"
							     :key="questions_to_display[questionIndex].id+AppStore.updatedKey" class="home-question">
								<divider-view v-if="question.format === 'divider'"></divider-view>
								<slider-view v-if="question.format === 'slider' && !questions_to_display[questionIndex].must_be_hide"
								             :rules="question.is_required ? { regex: /^[1-5]+$/ } : ''"
								             v-model="questions_to_display[questionIndex]"
								             :id="'q'+questions_to_display[questionIndex].id"
								             :questionIndex="questionIndex" :lang="AppStore.locale"></slider-view>
								<text-view v-if="question.format === 'text' && !questions_to_display[questionIndex].must_be_hide"
                           :rules="question.regex ? question.is_required ? 'required|regex:'+question.regex : 'regex:'+question.regex : question.is_required ? 'required' : ''"
								           v-model="questions_to_display[questionIndex]"
								           :id="'q'+questions_to_display[questionIndex].id"
								           :questionIndex="questionIndex" :lang="AppStore.locale"></text-view>
								<textarea-view v-if="question.format === 'textarea' && !questions_to_display[questionIndex].must_be_hide"
								               :rules="question.is_required ? 'required' : ''"
								               v-model="questions_to_display[questionIndex]"
								               :id="'q'+questions_to_display[questionIndex].id"
								               :questionIndex="questionIndex" :lang="AppStore.locale"></textarea-view>
								<select-view v-if="question.format === 'select' && !questions_to_display[questionIndex].must_be_hide"
								             :rules="question.is_required ? 'required' : ''"
								             return-object
								             :id="'q'+questions_to_display[questionIndex].id"
								             :name="questions_to_display[questionIndex].name"
								             v-model="questions_to_display[questionIndex]"
								             :questionIndex="questionIndex" :lang="AppStore.locale"></select-view>
								<checkbox-view v-if="question.format === 'checkbox' && !questions_to_display[questionIndex].must_be_hide"
								               :rules="question.is_required ? 'required' : ''"
								               :color="AppStore.data.general.primary_color"
								               :id="'q'+questions_to_display[questionIndex].id"
								               v-model="questions_to_display[questionIndex]"
								               :questionIndex="questionIndex" :lang="AppStore.locale"></checkbox-view>
								<radio-view v-if="question.format === 'radio' && !questions_to_display[questionIndex].must_be_hide"
								            :rules="question.is_required ? 'required' : ''"
								            :color="AppStore.data.general.primary_color"
								            :id="'q'+questions_to_display[questionIndex].id"
								            v-model="questions_to_display[questionIndex]"
								            :questionIndex="questionIndex" :lang="AppStore.locale"></radio-view>
								<switch-view v-if="question.format === 'switch' && !questions_to_display[questionIndex].must_be_hide"
								             :rules="question.is_required ? 'required' : ''"
								             :color="AppStore.data.general.primary_color"
								             :id="'q'+questions_to_display[questionIndex].id"
								             v-model="questions_to_display[questionIndex]"
								             :questionIndex="questionIndex" :lang="AppStore.locale"></switch-view>
							</div>
						</v-col>
						<v-col cols="12">
							<div v-show="_.includes([1,2,3,4,5], AppStore.rating.rate)">
								<!--								<v-btn @click="resetHomepage()" @keypress.enter="navigate" role="link" rounded-->
								<!--								       outlined elevation="0"-->
								<!--								       :large="AppStore.data.general.button_size === 'large'"-->
								<!--								       :x-large="AppStore.data.general.button_size === 'x-large'"-->
								<!--								       :x-small="AppStore.data.general.button_size === 'x-small'"-->
								<!--								       :small="AppStore.data.general.button_size === 'small'"-->
								<!--								       :color="AppStore.data.general.primary_color.hexa"-->
								<!--								       class="text-button mr-0 mr-sm-12 revert-btn"-->
								<!--								       :style="Helpers.getButtonSize(AppStore.data.general.button_size)"-->
								<!--								       v-html="AppStore.data.configuration[AppStore.locale].rate_retry_btn_text">-->
								<!--								</v-btn>-->

								<v-btn @click="passes(submit)" role="link" @keypress.enter="navigate" rounded
								       elevation="0" dark
								       :large="AppStore.data.general.button_size === 'large'"
								       :x-large="AppStore.data.general.button_size === 'x-large'"
								       :x-small="AppStore.data.general.button_size === 'x-small'"
								       :small="AppStore.data.general.button_size === 'small'"
								       :color="AppStore.data.general.primary_color.hexa"
								       class="text-button ml-0 ml-sm-12 ml-3 mt-sm-0"
								       :style="Helpers.getButtonSize(AppStore.data.general.button_size)"
								       v-html="AppStore.data.configuration[AppStore.locale].rate_validate_btn_text">
								</v-btn>
							</div>
						</v-col>
					</v-card>
					<v-card v-else elevation="0" class="mx-auto pa-sm-10 pa-md-16" rounded="xl"
					        :style="'margin-top:-'+AppStore.data.general.app_bar_size+'px'">
						<v-col cols="12" class="text-h5 my-auto">
							{{ $t('views.home.rating_already_given') + ' ' + getTimeBeforeNextRating }}
						</v-col>
					</v-card>
				</v-row>
			</v-container>
		</div>
	</ValidationObserver>
</template>

<script>
import {ValidationObserver} from 'vee-validate';
import AppStore from "../../../stores/AppStore";
import LocaleChanger from "../../../components/LocaleChanger.vue";
import _ from 'lodash';
import {EventBus} from "../../../services/Request";
import Helpers from "../../../services/Helpers";
import SliderView from "../../../components/communs/inputViewer3/SliderView.vue";
import RadioView from "../../../components/communs/inputViewer3/RadioView.vue";
import SelectView from "../../../components/communs/inputViewer3/SelectView.vue";
import TextareaView from "../../../components/communs/inputViewer3/TextareaView.vue";
import SwitchView from "../../../components/communs/inputViewer3/SwitchView.vue";
import CheckboxView from "../../../components/communs/inputViewer3/CheckboxView.vue";
import TextView from "../../../components/communs/inputViewer3/TextView.vue";
import DividerView from "../../../components/communs/inputViewer3/DividerView.vue";
import moment from "moment/moment";
import App from "../../../App.vue";

export default {
	name: 'home-view',

	data: () => ({
		AppStore,
		EventBus,
		questions: [],
		questions_to_display: [],
		started_home: false
	}),

	components: {
		DividerView, TextView, CheckboxView, SwitchView, TextareaView, SelectView, RadioView, SliderView,
		LocaleChanger,
		ValidationObserver
	},

	props: {},

	created() {
		if (!AppStore.started_app) {
			const url = this.$route.path.toString().split("/")
			EventBus.$emit('getApp', {
				type: url[1],
				model: url[2],
				slug: this.$route.params.slug,
				params: this.$route.query,
				noredirect: false
			})
		} else {
			this.startQuestions()
		}
		EventBus.$on('started-app', (data) => {
			this.startQuestions()
		});
		EventBus.$on('updateQuestion', (data) => {
			const index = _.findIndex(this.questions_to_display, (q) => {
				return q.id === data.question.id;
			}, 0)
			if (index !== -1){
				let newQuestionToDisplay = Object.assign([], this.questions_to_display)
				newQuestionToDisplay[index] = data.question
				this.questions_to_display = newQuestionToDisplay
			}
		});
	},

	mounted() {

	},

	computed: {
		App() {
			return App
		},
		Helpers() {
			return Helpers
		},
		_() {
			return _;
		},
		getTimeBeforeNextRating() {
			const duration = moment.duration(moment(this.$cookie.get(AppStore.data.slug)).diff(moment()));
			return moment.utc(duration.as('milliseconds')).format('HH:mm:ss')
		},
		negativeMarginTop() {
			return parseInt(AppStore.data.general.app_bar_size) + 30
		},
		getAnimationType() {
			return AppStore.data.configuration.stars_animation_type || 'pulse';
		}
	},

	watch: {},

	methods: {
		async startQuestions() {
			this.questions = []
			this.questions_to_display = []
			await this.getBookmarkedQuestions()
			if (AppStore.questions_by_page[1] && AppStore.questions_by_page[1].length > AppStore.data.configuration.questions_to_display_1) {
				await this.getRandomQuestions();
			} else {
				this.questions = Object.assign([], _.filter(AppStore.questions_by_page[1], (q) => {
					return !q.is_bookmarked
				}))
				this.questions_to_display = this.questions_to_display.concat(this.questions)
			}
			this.started_home = true
		},

		getBookmarkedQuestions() {
			this.questions_to_display = Object.assign([], AppStore.bookmarkedQuestions[1])
		},

		getRandomQuestions() {
			const max = AppStore.data.configuration.questions_to_display_1 - this.questions_to_display.length
			this.questions = Object.assign([], _.filter(AppStore.questions_by_page[1], (q) => {
				return !q.is_bookmarked
			}))

			for (let i = 0; i < max; i++) {
				const randomQuestionIndex = Math.floor(Math.random() * (this.questions.length));
				this.questions_to_display.push(this.questions[randomQuestionIndex]);
				this.questions.splice(randomQuestionIndex, 1)
			}
		},

		submit() {
			if (AppStore.data.configuration.skip_appreciation_page) {
				this.$router.push({name: 'mb-3-comment'})
			} else {
				this.$router.push({name: 'mb-3-appreciation'})
			}
		},

		getRateColor(isFilled) {
			let color = 'orange'
			if (isFilled) {
				if (!AppStore.data.configuration.override_rate_stars_color && AppStore.data.configuration.default_rate_stars_color.hexa) {
					color = AppStore.data.configuration.default_rate_stars_color.hexa
				} else {
					color = AppStore.data.configuration['override_rate_stars_color_star_' + AppStore.rating.rate].hexa
				}
			} else {
				color = 'grey lighten-0'
			}

			return color
		},
	}
}
</script>
<style>
/* Animation 1: Pulsation douce (actuelle) */
@keyframes star-pulse {
  0% { transform: scale(1); }
  10% { transform: scale(1.1); }
  20% { transform: scale(1); }
  100% { transform: scale(1); }
}

.rate-icon-pulse {
  animation-name: star-pulse;
  animation-duration: 5s;
  animation-iteration-count: infinite;
  transform-origin: center;
  letter-spacing: -9px!important;
}

/* Animation 2: Rotation scintillante */
@keyframes star-sparkle {
  0% {
    transform: scale(1) rotateY(0deg);
    filter: brightness(1);
  }
  25% {
    transform: scale(1.15) rotateY(180deg);
    filter: brightness(1.3);
  }
  50% {
    transform: scale(1) rotateY(360deg);
    filter: brightness(1);
  }
  75% {
    transform: scale(1.05) rotateY(180deg);
    filter: brightness(1.2);
  }
  100% {
    transform: scale(1) rotateY(0deg);
    filter: brightness(1);
  }
}

.rate-icon-sparkle {
  animation-name: star-sparkle;
  animation-duration: 7s;
  animation-iteration-count: infinite;
  transform-origin: center;
  letter-spacing: -9px!important;
}

/* Animation 3: Rebondissement */
@keyframes star-bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0) scale(1);
  }
  10% {
    transform: translateY(-15px) scale(1.1);
  }
  30% {
    transform: translateY(-10px) scale(1.05);
  }
  60% {
    transform: translateY(-5px) scale(1.02);
  }
}

.rate-icon-bounce {
  animation-name: star-bounce;
  animation-duration: 3.5s;
  animation-iteration-count: infinite;
  transform-origin: center;
  letter-spacing: -9px!important;
}

/* Animation de sélection (commune à toutes) */
@keyframes star-expand {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

.star-expand {
  animation-name: star-expand;
  animation-duration: 0.6s;
  animation-iteration-count: 1;
  transform-origin: center;
  animation-delay: 0s !important;
}

/* ========================================== */
/* Animation 4: Vague élégante (wave) */
/* ========================================== */

/* Animation au chargement - Mouvement de vague fluide */
@keyframes star-wave {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  25% {
    transform: translateY(-8px) rotate(-5deg);
  }
  50% {
    transform: translateY(0) rotate(0deg);
  }
  75% {
    transform: translateY(-4px) rotate(5deg);
  }
}

.rate-icon-wave {
  animation-name: star-wave;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  transform-origin: center;
  letter-spacing: -9px!important;
}

/* Animation au clic - Cascade de vagues */
@keyframes star-wave-select {
  0% {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
  20% {
    transform: scale(1.3) translateY(-20px);
    opacity: 1;
  }
  40% {
    transform: scale(1.1) translateY(-5px);
  }
  60% {
    transform: scale(1.2) translateY(-15px);
  }
  80% {
    transform: scale(1.05) translateY(-3px);
  }
  100% {
    transform: scale(1) translateY(0);
  }
}

.star-wave-select {
  animation-name: star-wave-select;
  animation-duration: 0.8s;
  animation-iteration-count: 1;
  animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transform-origin: center;
  animation-delay: 0s !important;
}

/* ========================================== */
/* Animation 5: Lueur pulsante (glow) */
/* ========================================== */

/* Animation au chargement - Halo lumineux élégant */
@keyframes star-glow {
  0%, 100% {
    filter: drop-shadow(0 0 0px currentColor) brightness(1);
    transform: scale(1);
  }
  50% {
    filter: drop-shadow(0 0 0px currentColor) drop-shadow(0 0 0px currentColor) brightness(1.1);
    transform: scale(1.09);
  }
}

.rate-icon-glow {
  animation-name: star-glow;
  animation-duration: 5s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  transform-origin: center;
  letter-spacing: -9px!important;
}

/* Animation au clic - Explosion lumineuse */
@keyframes star-glow-select {
  0% {
    filter: drop-shadow(0 0 0px currentColor) brightness(1);
    transform: scale(1);
  }
  30% {
    filter: drop-shadow(0 0 0px currentColor) drop-shadow(0 0 0px currentColor) brightness(1.3);
    transform: scale(1.6);
  }
  60% {
    filter: drop-shadow(0 0 0px currentColor) brightness(1.2);
    transform: scale(1.45);
  }
  100% {
    filter: drop-shadow(0 0 0px currentColor) brightness(1.1);
    transform: scale(1);
  }
}

.star-glow-select {
  animation-name: star-glow-select;
  animation-duration: 0.7s;
  animation-iteration-count: 1;
  animation-timing-function: ease-out;
  transform-origin: center;
  animation-delay: 0s !important;
}

/* ========================================== */
/* Animation 6: Balancement gracieux (swing) */
/* ========================================== */

/* Animation au chargement - Balancement pendulaire */
@keyframes star-swing {
  0%, 100% {
    transform: rotate(0deg) scale(1);
  }
  20% {
    transform: rotate(7deg) scale(1.05);
  }
  40% {
    transform: rotate(-5deg) scale(1.02);
  }
  60% {
    transform: rotate(3deg) scale(1.03);
  }
  80% {
    transform: rotate(-2deg) scale(1.01);
  }
}

.rate-icon-swing {
  animation-name: star-swing;
  animation-duration: 4s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  transform-origin: top center;
  letter-spacing: -9px!important;
}

/* Animation au clic - Rotation festive */
@keyframes star-swing-select {
  0% {
    transform: rotate(0deg) scale(1);
  }
  25% {
    transform: rotate(25deg) scale(1.3);
  }
  50% {
    transform: rotate(-20deg) scale(1.2);
  }
  75% {
    transform: rotate(10deg) scale(1.1);
  }
  100% {
    transform: rotate(0deg) scale(1);
  }
}

.star-swing-select {
  animation-name: star-swing-select;
  animation-duration: 0.6s;
  animation-iteration-count: 1;
  animation-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
  transform-origin: top center;
  animation-delay: 0s !important;
}

/* ========================================== */
/* Animations de sélection pour les 3 premières */
/* ========================================== */

/* Animation sparkle au clic */
@keyframes star-sparkle-select {
  0% {
    transform: scale(1) rotateY(0deg);
    filter: brightness(1);
  }
  50% {
    transform: scale(1.4) rotateY(180deg);
    filter: brightness(1.5);
  }
  100% {
    transform: scale(1) rotateY(360deg);
    filter: brightness(1.1);
  }
}

.star-sparkle-select {
  animation-name: star-sparkle-select;
  animation-duration: 0.6s;
  animation-iteration-count: 1;
  transform-origin: center;
  animation-delay: 0s !important;
}

/* Animation bounce au clic */
@keyframes star-bounce-select {
  0% {
    transform: translateY(0) scale(1);
  }
  30% {
    transform: translateY(-30px) scale(1.3);
  }
  50% {
    transform: translateY(0) scale(1.1);
  }
  70% {
    transform: translateY(-15px) scale(1.15);
  }
  85% {
    transform: translateY(0) scale(1.05);
  }
  100% {
    transform: translateY(0) scale(1);
  }
}

.star-bounce-select {
  animation-name: star-bounce-select;
  animation-duration: 0.7s;
  animation-iteration-count: 1;
  transform-origin: center;
  animation-delay: 0s !important;
}

.v-icon{
  letter-spacing: -9px!important;
}
</style>